<template>
    <router-link :to="route" :class="{ 'is-active': isActive }" @click="closeMenu">
        {{ item.title }}
    </router-link>
</template>

<script>
import has from 'lodash/has.js';

import ActiveStatusMixin from '@/mixins/ActiveStatus.mixin.js';

export default {
    name: 'StudentGradebook',

    mixins: [ActiveStatusMixin],

    props: {
        closeMenu: {
            type: Function,
            default: () => {},
        },

        item: {
            required: true,
            type: Object,
        },
    },

    computed: {
        route() {
            if (!has(this.item, 'course_id')) {
                throw new Error(
                    `Course id must be present on the item that is passed to <course>. Received: ${JSON.stringify(
                        this.item
                    )}`
                );
            }

            return {
                name: 'student-grade-view',
                params: {
                    courseId: this.item.course_id,
                    userId: this.item.route.user_id,
                },
            };
        },
    },
};
</script>
